"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("../components");
var Shortcuts_1 = __importDefault(require("../Shortcuts"));
var Info_less_1 = __importDefault(require("./Info.less"));
var Info = (0, react_1.forwardRef)(function (_, ref) {
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(components_1.Section, { ref: ref, label: t('CAROLINE_SETTINGS_ABOUT', { defaultValue: 'Sobre' }) },
        react_1.default.createElement("div", { className: Info_less_1.default['info'] },
            react_1.default.createElement("div", { className: Info_less_1.default['brand'] }, t('CAROLINE_APP_NAME', { defaultValue: 'Caroline' })),
            react_1.default.createElement("p", null,
                t('SETTINGS_APP_VERSION'),
                ": ",
                process.env.VERSION),
            react_1.default.createElement("p", null,
                t('TERMS_OF_SERVICE'),
                ": ",
                t('CAROLINE_LEGAL_UNPUBLISHED', { defaultValue: 'Ainda não publicado' })),
            react_1.default.createElement("p", null,
                t('PRIVACY_POLICY'),
                ": ",
                t('CAROLINE_LEGAL_UNPUBLISHED', { defaultValue: 'Ainda não publicado' })),
            react_1.default.createElement("details", { className: Info_less_1.default['shortcuts'] },
                react_1.default.createElement("summary", null, t('SETTINGS_NAV_SHORTCUTS')),
                react_1.default.createElement(Shortcuts_1.default, { embedded: true })))));
});
exports.default = Info;
